import { Outlet } from '@tanstack/react-router';

export const RouterRoot = () => {
  return <Outlet />;
};
